<template>
  <div class="space_management_background">
    <div class="space_title">纪念堂管理</div>
    <div class="search_area">
      <el-form ref="form" :model="spaceSearchForm" :inline="true">
        <el-form-item
          class="search_item"
          label="创建日期："
          label-width="9.7rem"
        >
          <el-date-picker
            v-model="spaceSearchForm.date"
            type="daterange"
            range-separator="-"
            value-format="yyyy-MM-dd"
            start-placeholder="年/月/日"
            end-placeholder="年/月/日"
            :picker-options="datePickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="search_item" label="纪念堂来源：">
          <el-autocomplete
            class="search_input"
            placeholder="请输入纪念堂来源"
            v-model.trim="spaceSearchForm.appShortName"
            :fetch-suggestions="querySearch"
            @select="handleSelect"
            clearable
            @clear="setBlur()"
            @input="handle"
          ></el-autocomplete>
        </el-form-item>
        <!-- <el-form-item class="search_item" label="纪念堂编号：">
          <el-input
            class="search_input"
            maxlength="50"
            placeholder="请输入纪念堂编号"
            v-model.trim="spaceSearchForm.code"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item class="search_item" label="纪念堂信息：">
          <el-input
            class="search_input"
            maxlength="30"
            placeholder="请输入纪念堂名称/编号"
            v-model="spaceSearchForm.codeOrName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="search_item" label="备注：">
          <el-input
            class="search_input"
            maxlength="50"
            placeholder="请输入逝者姓名"
            v-model="spaceSearchForm.remarkName"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          class="search_item_b"
          label="手机号："
          label-width="9.7rem"
        >
          <el-input
            class="search_input"
            maxlength="11"
            placeholder="请输入手机号"
            v-model="spaceSearchForm.undertakerTel"
            @input="
              (v) => {
                this.spaceSearchForm.undertakerTel = v.replace(/[^\d]/g, '');
              }
            "
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="search_item_b" label="App登录：">
          <el-select
            class="search_input"
            v-model="spaceSearchForm.loginMobileState"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in loginMobileStateList"
              :label="item.areaName"
              :value="item.areaId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search_item_b" label="告别厅：">
          <el-select
            class="search_input"
            v-model="spaceSearchForm.fhId"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in farewellOfficeList"
              :label="item.nameAll"
              :value="item.id"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search_item_b" label="告别会日期：">
          <el-date-picker
            v-model="spaceSearchForm.amUseDate"
            type="date"
            placeholder="年/月/日"
            value-format="yyyy-MM-dd"
            :picker-options="datePickerOptionsA"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item class="search_item_b" label="编辑状态：">
          <el-select
            class="search_input"
            v-model="spaceSearchForm.updateState"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in changeStateList"
              :label="item.areaName"
              :value="item.areaId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="search_item_b" label="纪念堂状态：">
          <el-select
            class="search_input"
            v-model="spaceSearchForm.status"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in stateList"
              :label="item.areaName"
              :value="item.areaId"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item class="search_item_b" label-width="4rem">
          <el-button
            class="search_button"
            type="primary"
            @click="search"
            style="background-color: #4ea2ff; border-color: #4ea2ff"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="space_list_title">
      <div class="space_list_title_item" v-if="pms.listAll">
        <div
          :class="
            title == 0 ? 'space_list_title_text' : 'space_list_title_text_no'
          "
          style="width: 8.5rem; padding-left: 3rem"
          @click="changeTitle(0)"
        >
          全部
        </div>
        <div
          class="space_list_title_line"
          v-if="title == 0"
          style="left: 3rem"
        ></div>
      </div>
      <!-- <div class="space_list_title_item" v-if="pms.listV">
        <div
          :class="
            title == 1 ? 'space_list_title_text' : 'space_list_title_text_no'
          "
          style="width: 12rem; padding-left: 2rem"
          @click="changeTitle(1)"
        >
          访问码冻结
        </div>
        <div
          class="space_list_title_line"
          v-if="title == 1"
          style="left: 2.2rem"
        ></div>
      </div> -->
      <div class="space_list_title_item" v-if="pms.listS">
        <div
          :class="
            title == 2 ? 'space_list_title_text' : 'space_list_title_text_no'
          "
          style="width: 12rem; padding-left: 2rem"
          @click="changeTitle(2)"
        >
          纪念堂冻结
        </div>
        <div
          class="space_list_title_line"
          v-if="title == 2"
          style="left: 2.2rem"
        ></div>
      </div>
    </div>

    <div class="line"></div>
    <div class="space_middle_all">
      <div class="space_middle">
        <div class="space_middle_total">
          合计：<span class="space_middle_number">{{ number }}</span>
        </div>
        <el-button
          class="btn_create right"
          @click="createSpace()"
          v-if="pms.create && title == 0"
        >
          <div class="btn_content">
            <div class="icon-create"></div>
            <div class="text_create">新建</div>
          </div>
        </el-button>
      </div>

      <div class="table_area" v-if="pms.listAll || pms.listV || pms.listS">
        <el-table :data="totalList">
          <el-table-column label="创建日期" :width="11 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div>{{ scope.row.createTimeS }}</div>
                <div style="margin-top: 0.5rem">
                  {{ scope.row.createTimeE }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="unitShortName"
            label="纪念堂来源"
            :width="11.0 * docFontSize"
          ></el-table-column>
          <el-table-column
            prop="code"
            label="纪念堂编号"
            :width="11.0 * docFontSize"
          ></el-table-column>
          <el-table-column label="纪念堂名称" :width="15.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div class="v_item_name_small">{{ scope.row.name }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="备注" :width="20.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div class="v_item_name_a">
                  逝者姓名：{{ scope.row.remarkName }}
                </div>
                <div class="v_item_name">
                  生辰：{{ scope.row.remarkBirthday }}
                </div>
                <div class="v_item_name">
                  忌辰：{{ scope.row.remarkDeadday }}
                </div>
                <div class="v_item_name_a">
                  主办人姓名：{{ scope.row.undertakerName }}
                </div>
                <el-button
                  type="text"
                  @click="toRemark(scope.row)"
                  v-if="pms.remark"
                  style="padding: 0rem 0rem"
                  >编辑</el-button
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column label="主办人手机号" :width="18.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div>{{ scope.row.undertakerTel }}</div>
                <div v-if="scope.row.loginMobileState != null" class="v_item_name" style="margin-top:0.5rem;">
                  App登录：{{ scope.row.loginMobileState == 1 ? '是' : '否' }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="殡仪馆告别厅使用" :width="14.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div class="v_item_name">{{ scope.row.nameA }}</div>
                <div>{{ scope.row.useDate }}</div>
                <div>{{ scope.row.dateA }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="陵园告别厅使用" :width="12.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div class="v_item_name">{{ scope.row.nameB }}</div>
                <div>{{ scope.row.useDate }}</div>
                <div>{{ scope.row.dateB }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="编辑状态" :width="9.0 * docFontSize">
            <template slot-scope="scope">
              <div>
                <div style="color: #2c90ff" v-if="scope.row.updateState == 1">
                  编辑中
                </div>
                <div style="color: #2c90ff" v-if="scope.row.uploadState == 1">
                  上传中
                </div>
                <div
                  v-if="
                    scope.row.updateState == 0 && scope.row.uploadState == 0
                  "
                >
                  —
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="纪念堂状态" :width="10.0 * docFontSize">
            <template slot-scope="scope">
              <div
                :style="
                  scope.row.statusName == '已冻结'
                    ? 'color: #FF4A24;'
                    : 'color: #333333;'
                "
              >
                {{ scope.row.statusName }}
              </div>
              <div
                :style="
                  scope.row.statusNameLock == '已冻结'
                    ? 'color: #FF4A24;'
                    : 'color: #333333;'
                "
              >
                {{ scope.row.statusNameLock }}
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="访问码冻结状态" :width="9.0 * docFontSize">
            <template slot-scope="scope">
              <div
                :style="
                  scope.row.visitorFrozenName != ''
                    ? 'color: #FF4A24;'
                    : 'color: #333333;'
                "
              >
                {{ scope.row.visitorFrozenName }}
              </div>
            </template>
          </el-table-column> -->

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toDetails(scope.row)"
                v-if="pms.details"
                style="padding: 0.8rem 0rem"
                >详情</el-button
              >
              <el-button
                type="text"
                @click="showLog(scope.row)"
                style="margin-left: 2rem; padding: 0.8rem 0rem"
                v-if="pms.log"
                >日志</el-button
              >
              <el-button
                type="text"
                @click="subscribeOffice(scope.row)"
                style="margin-left: 2rem; padding: 0.8rem 0rem"
                v-if="pms.change"
                :disabled="scope.row.spaceFrozen != 0 || isCanClick"
                >预约告别厅</el-button
              >
              <el-button
                type="text"
                class="bt_cancle"
                style="padding: 0.8rem 0rem"
                @click="unfreezeSpace(scope.row)"
                :disabled="scope.row.spaceFrozen == 0"
                v-if="pms.relieveS"
                >解除纪念堂冻结</el-button
              >
              <el-button
                type="text"
                class="bt_cancle"
                style="margin-left: 2rem; padding: 0.8rem 0rem"
                @click="projectionScreen(scope.row)"
                v-if="pms.projectionScreen"
                :disabled="scope.row.spaceFrozen == 1 || scope.row.status == 2"
                >投屏</el-button
              >
              <el-button
                type="text"
                class="bt_cancle"
                style="margin-left: 2rem; padding: 0.8rem 0rem"
                @click="sweep(scope.row)"
                v-if="pms.sweep"
                >线下祭祀</el-button
              >
              <!-- <el-button
                type="text"
                @click="unfreezeCaller(scope.row)"
                style="margin-left: 2rem; padding: 0.8rem 0rem"
                :disabled="scope.row.visitorFrozen == 0"
                v-if="pms.relieveV"
                >解除冻结访问码</el-button
              > -->
            </template>
          </el-table-column>
          <template slot="empty">
            <table-empty></table-empty>
          </template>
        </el-table>
      </div>

      <div class="page_area" v-if="pms.listAll || pms.listV || pms.listS">
        <el-pagination
          v-if="title == 0"
          :current-page.sync="pageManagementAll.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageManagementAll.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageManagementAll.size"
        >
        </el-pagination>
        <el-pagination
          v-if="title == 1"
          :current-page.sync="pageManagementV.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageManagementV.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageManagementV.size"
        >
        </el-pagination>
        <el-pagination
          v-if="title == 2"
          :current-page.sync="pageManagementS.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageManagementS.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageManagementS.size"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="解除冻结访问码"
      width="129rem"
      :visible.sync="unfreezeCallerDialog"
      :close-on-click-modal="false"
      :before-close="handleCallerClose"
    >
      <div class="dialog_body_create" style="margin-bottom: 8rem">
        <div class="unfreeze_title_all">
          <div class="unfreeze_title_all_text">冻结备注：</div>
          <div class="unfreeze_title_search_input_another">
            {{ visitorFrozenContentNew.visitorFrozenRemark }}
            <span class="search_input_big_number_another"
              >{{ visitorFrozenContentNew.visitorFrozenRemark | remarkLength
              }}<span class="search_input_big_number_a">/100</span></span
            >
          </div>
        </div>

        <div class="unfreeze_middle">
          <div class="unfreeze_middle_title" style="margin-left: 1rem">
            冻结内容：
          </div>

          <div class="unfreeze_middle_content" style="margin-left: 1rem">
            <div class="unfreeze_middle_content_title">
              {{ visitorFrozenContent.lifeTitle1 }}
            </div>
            <div
              v-html="visitorFrozenContent.lifeStory1"
              class="unfreeze_middle_content_text"
            ></div>
            <div class="unfreeze_middle_content_title">
              {{ visitorFrozenContent.lifeTitle2 }}
            </div>
            <div
              v-html="visitorFrozenContent.lifeStory2"
              class="unfreeze_middle_content_text"
            ></div>
            <img
              class="unfreeze_middle_img"
              :src="visitorFrozenContent.coverUrl"
              alt=""
              style="margin-top: 2rem; margin-left: 1rem"
            />
            <div class="v_template_imgs_a">
              <div
                class="v_template_item_a"
                v-for="(item, i) in visitorFrozenContent.photoList"
                :key="i"
                style="margin-left: 1rem"
              >
                <img class="iv_template_a" alt="" :src="item.photoUrl" />
              </div>
            </div>
          </div>

          <div class="unfreeze_middle_title" style="margin-left: 3rem">
            审核解冻内容：
          </div>

          <div class="unfreeze_middle_content" style="margin-left: 1rem">
            <div
              class="unfreeze_middle_content_title"
              v-if="visitorFrozenContentNew.visitorFrozen == 2"
            >
              {{ visitorFrozenContentNew.lifeTitle1 }}
            </div>
            <div
              v-html="visitorFrozenContentNew.lifeStory1"
              class="unfreeze_middle_content_text"
              v-if="visitorFrozenContentNew.visitorFrozen == 2"
            ></div>
            <div
              class="unfreeze_middle_content_title"
              v-if="visitorFrozenContentNew.visitorFrozen == 2"
            >
              {{ visitorFrozenContentNew.lifeTitle2 }}
            </div>
            <div
              v-html="visitorFrozenContentNew.lifeStory2"
              class="unfreeze_middle_content_text"
              v-if="visitorFrozenContentNew.visitorFrozen == 2"
            ></div>
            <img
              class="unfreeze_middle_img"
              :src="visitorFrozenContentNew.coverUrl"
              alt=""
              style="margin-top: 2rem; margin-left: 1rem"
              v-if="visitorFrozenContentNew.visitorFrozen == 2"
            />
            <div
              class="v_template_imgs_a"
              v-if="visitorFrozenContentNew.visitorFrozen == 2"
            >
              <div
                class="v_template_item_a"
                v-for="(item, i) in visitorFrozenContentNew.photoList"
                :key="i"
                style="margin-left: 1rem"
              >
                <img class="iv_template_a" alt="" :src="item.photoUrl" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          plain
          @click="callerCancle()"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="
            background-color: #ff4a4a;
            border-color: #ff4a4a;
            color: #ffffff;
          "
          @click="callerReject()"
          >驳回</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="callerQuery()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="解除纪念堂冻结"
      width="61rem"
      :visible.sync="unfreezeSpaceDialog"
      :close-on-click-modal="false"
      :before-close="handleSpaceClose"
    >
      <div class="dialog_body_space" style="margin-bottom: 3rem">
        <el-input
          class="space_input"
          v-model.trim="messageClock"
          maxlength="6"
          placeholder="请输入验证码"
          clearable
        ></el-input>
        <el-button
          class="get_phone_message"
          type="warning"
          v-if="!timerClock"
          @click="getMessageClock"
          >获取验证码</el-button
        >
        <el-button v-else class="message_to_phone"
          >{{ totleTimeClock }}s</el-button
        >
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          plain
          @click="callerSpaceCancle()"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="callerSpaceQuery()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="新建"
      width="61rem"
      :visible.sync="createSpaceDialog"
      :close-on-click-modal="false"
      :before-close="handleClose"
      class="partI"
    >
      <!-- :hide-required-asterisk="true" -->
      <div class="dialog_body_create" style="margin-bottom: 3rem">
        <el-form
          ref="createForm"
          :model="createForm"
          label-width="21rem"
          :rules="createRules"
        >
          <el-form-item label="纪念堂名称：" prop="name" class="search_item_a">
            <el-input
              class="space_input"
              maxlength="30"
              placeholder="请输入纪念堂名称"
              v-model="createForm.name"
              clearable
            ></el-input>
          </el-form-item>

          <!-- <el-form-item
            label="逝者姓名："
            prop="deadName"
            class="search_item_a"
          >
            <el-input
              class="space_input"
              maxlength="30"
              placeholder="请输入逝者姓名"
              v-model.trim="createForm.deadName"
              clearable
            ></el-input>
          </el-form-item> -->

          <!-- <el-form-item
            label="主办人姓名："
            prop="undertakerName"
            class="search_item_a"
          >
            <el-input
              class="space_input"
              maxlength="30"
              placeholder="请输入主办人姓名"
              v-model="createForm.undertakerName"
              clearable
            ></el-input>
          </el-form-item> -->

          <!-- <el-form-item
            label="主办人电话："
            prop="undertakerTel"
            class="search_item_a"
          >
            <el-input
              class="space_input"
              maxlength="11"
              placeholder="请输入主办人电话"
              v-model="createForm.undertakerTel"
              @input="(v)=>{this.createForm.undertakerTel = v.replace(/[^\d]/g,'')}"
              clearable
            ></el-input>
          </el-form-item> -->
          <el-form-item
            label="纪念堂封面："
            prop="coverType"
            class="search_item_a"
          >
            <div class="cover_type">
              <el-checkbox v-model="coverType0">本地照片</el-checkbox>
              <el-checkbox v-model="coverType1">使用默认</el-checkbox>
            </div>
            <div class="cover_upload_area">
              <OSSUpload
                :type="11"
                @fileInfo="coverFileInfo"
                :imageUrl="createForm.coverUrl"
                v-if="coverType0"
              ></OSSUpload>
              <img
                class="cover"
                v-if="coverType1"
                src="@/assets/images/space/default_photo.png"
              />
            </div>
          </el-form-item>
        </el-form>
        <div class="upload_tips">
          照片格式为jpg或png，大小为10KB~10MB，图片尺寸为285×380
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          plain
          @click="dialogCancel('createForm')"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogSave('createForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      :title="isCreate ? '预约告别厅' : '修改告别厅'"
      width="61rem"
      :visible.sync="subscribeOfficeDialog"
      :close-on-click-modal="false"
      :before-close="handleOfficeClose"
    >
      <div class="dialog_body_create" style="margin-bottom: 3rem">
        <el-form
          ref="officeForm"
          :model="officeForm"
          label-width="16rem"
          :rules="officeRules"
        >
          <!-- :hide-required-asterisk="true" -->
          <el-form-item label="告别厅：" prop="office">
            <el-select
              class="search_input"
              v-model="officeForm.office"
              placeholder="请选择"
              @change="selectChange"
            >
              <el-option
                v-for="item in officeList"
                :label="item.nameAll"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="使用时间：" prop="date">
            <el-date-picker
              v-model="officeForm.date"
              :picker-options="pickerBeginDateAfter"
              type="date"
              placeholder="请选择"
              :editable="false"
              value-format="yyyy-MM-dd"
              style="width: 14rem"
            >
            </el-date-picker>
            <el-time-select
              class="startTime"
              placeholder="开始时间"
              :editable="false"
              v-model="officeForm.startTime"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:45',
                maxTime: officeForm.endTime,
              }"
              style="width: 12rem"
            >
            </el-time-select>
            <el-time-select
              class="endTime"
              placeholder="结束时间"
              :editable="false"
              v-model="officeForm.endTime"
              :picker-options="{
                start: '00:00',
                step: '00:15',
                end: '23:45',
                minTime: officeForm.startTime,
              }"
              style="width: 12rem"
            >
            </el-time-select>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          plain
          @click="dialogOfficeCancel('officeForm')"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogOfficeSave('officeForm')"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="备注"
      width="61rem"
      :visible.sync="remarkDialog"
      :close-on-click-modal="false"
      :before-close="handleRemarkClose"
    >
      <div class="dialog_body_create" style="margin-bottom: 3rem">
        <div class="cemetery_use">
          <div class="cemetery_use_title">逝者姓名：</div>
          <el-input
            class="search_input_big"
            type="textarea"
            v-model="remarkName"
            placeholder="请输入逝者姓名"
            :autosize="{ minRows: 1, maxRows: 3 }"
            resize="none"
            maxlength="30"
          >
          </el-input>
        </div>

        <div class="cemetery_use" style="align-items: center; margin-top: 3rem">
          <div class="cemetery_use_title">生辰：</div>
          <el-date-picker
            v-model="remarkBirthday"
            type="date"
            placeholder="年/月/日"
            value-format="yyyy-MM-dd"
            :picker-options="datePickerOptionsB"
          >
          </el-date-picker>
        </div>

        <div class="cemetery_use" style="align-items: center; margin-top: 3rem">
          <div class="cemetery_use_title">忌辰：</div>
          <el-date-picker
            v-model="remarkDeadday"
            type="date"
            placeholder="年/月/日"
            value-format="yyyy-MM-dd"
            :picker-options="datePickerOptionsB"
          >
          </el-date-picker>
        </div>

        <div class="cemetery_use" style="align-items: center; margin-top: 3rem">
          <div class="cemetery_use_title">主办人姓名：</div>
          <el-input
            class="search_input_big"
            type="textarea"
            v-model="remarkNamePeo"
            placeholder="请输入主办人姓名"
            :autosize="{ minRows: 1, maxRows: 3 }"
            resize="none"
            maxlength="30"
          >
          </el-input>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          style="width: 10rem; margin-right: 1.5rem"
          plain
          @click="dialogRemarkCancel()"
          >取消</el-button
        >
        <el-button
          class="dialog_button"
          style="background-color: #4ea2ff; border-color: #4ea2ff"
          type="primary"
          @click="dialogRemarkSave()"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-drawer
      title="日志"
      :visible.sync="tableLog"
      direction="rtl"
      :size="drawarWidth"
      custom-class="drawer_change"
      :before-close="handleCloseLog"
      :wrapperClosable="false"
    >
      <div class="search_area_log_middle">
        <div class="search_area_log">
          <el-form ref="form" :model="spaceLogForm" label-width="11rem">
            <el-form-item class="search_item_c" label="操作员：">
              <el-input
                class="search_input"
                maxlength="60"
                placeholder="请输入操作员名称"
                v-model.trim="spaceLogForm.createUserName"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item class="search_item_c" label="操作内容：">
              <el-input
                class="search_input"
                maxlength="60"
                placeholder="请输入操作内容"
                v-model.trim="spaceLogForm.content"
                clearable
              ></el-input>
            </el-form-item>

            <el-form-item class="search_item_c" label="操作日期：">
              <el-date-picker
                v-model="spaceLogForm.date"
                type="daterange"
                range-separator="-"
                value-format="yyyy-MM-dd"
                start-placeholder="年/月/日"
                end-placeholder="年/月/日"
                :picker-options="datePickerOptions"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item class="search_item_c" label-width="5.5rem">
              <el-button
                class="search_button"
                type="primary"
                @click="searchLog()"
                style="
                  background-color: #4ea2ff;
                  border-color: #4ea2ff;
                  margin-left: 50rem;
                "
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <div class="table_area_log_all">
          <div class="log_number_all">
            合计：<span class="log_number_blue">{{ numberLog }}</span>
          </div>

          <div class="table_area_log">
            <el-table :data="logList">
              <el-table-column
                prop="index"
                label="序号"
                :width="10.0 * docFontSize"
              ></el-table-column>
              <el-table-column label="操作员信息" :width="24.0 * docFontSize">
                <template slot-scope="scope">
                  <div>
                    <div class="v_item_name" v-if="scope.row.unitShortName">
                      单位简称：{{ scope.row.unitShortName }}
                    </div>
                    <div class="v_item_name">
                      账号：{{ scope.row.createUserName }}
                    </div>
                    <div class="v_item_name">
                      使用者：{{ scope.row.createUserNick }}
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作内容" :width="58.0 * docFontSize">
                <template slot-scope="scope">
                  <div>
                    <div class="table_area_log_item">
                      {{
                        scope.row.contentDetailJs != ""
                          ? scope.row.contentNew
                          : scope.row.content
                      }}
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 1 && scope.row.contentDetailJs != ''
                      "
                    >
                      <div>纪念堂名称：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.name }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 1 && scope.row.contentDetailJs != ''
                      "
                    >
                      <div>纪念堂封面：</div>
                      <img
                        :src="scope.row.contentDetailJs.coverUrl"
                        class="table_area_log_item_img"
                      />
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 2 && scope.row.contentDetailJs != ''
                      "
                    >
                      <div>告别厅：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.unitName }}
                        {{ scope.row.contentDetailJs.fhName }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 2 && scope.row.contentDetailJs != ''
                      "
                    >
                      <div>使用时间：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.useDate }}
                        {{ scope.row.contentDetailJs.startTime }} -
                        {{ scope.row.contentDetailJs.endTime }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 3 && scope.row.contentDetailJs != ''
                      "
                    >
                      <div>冻结理由：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.spaceFrozenRemark }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.name &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>纪念堂名称：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.name }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.gender &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>性别：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.gender }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.birthday &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>生辰：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.birthday }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.deadday &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>忌辰：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.deadday }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.coverUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>纪念堂封面：</div>
                      <img
                        :src="scope.row.contentDetailJs.coverUrl"
                        class="table_area_log_item_img"
                      />
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.lifeStory &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>生平：</div>
                      <div
                        class="table_area_log_item_title"
                        v-html="scope.row.contentDetailJs.lifeStory"
                      ></div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.bgId &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>风格模板：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.bgId }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 9 &&
                        scope.row.contentDetailJs.msId &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>音乐：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.msId }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 10 &&
                        scope.row.contentDetailJs.cemetery &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>陵园使用内容：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.cemetery }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 11 &&
                        scope.row.contentDetailJs.posterName1 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第一行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName1 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 11 &&
                        scope.row.contentDetailJs.posterName2 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第二行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName2 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 11 &&
                        scope.row.contentDetailJs.posterName3 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第三行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName3 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 11 &&
                        scope.row.contentDetailJs.posterName4 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第四行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName4 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 13 &&
                        scope.row.contentDetailJs.photoUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>上传文件：</div>
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=image/resize,m_fill,h_40,w_40'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 1"
                      />
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=video/snapshot,t_1000,f_jpg,w_40,h_40,m_fast'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 2"
                      />
                      <div
                        class="table_area_log_item_title_a"
                        style="margin-left: 1rem"
                      >
                        {{ scope.row.contentDetailJs.photoName }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 13 &&
                        scope.row.contentDetailJs.photoResult &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>上传结果：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.photoResult }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 16 &&
                        scope.row.contentDetailJs.remarkName &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>逝者姓名：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.remarkName }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 16 &&
                        scope.row.contentDetailJs.remarkBirthday &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>生辰：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.remarkBirthday }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 16 &&
                        scope.row.contentDetailJs.remarkDeadday &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>忌辰：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.remarkDeadday }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 16 &&
                        scope.row.contentDetailJs.undertakerName &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>主办人姓名：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.undertakerName }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 19 &&
                        scope.row.contentDetailJs.photoUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>删除文件：</div>
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=image/resize,m_fill,h_40,w_40'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 1"
                      />
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=video/snapshot,t_1000,f_jpg,w_40,h_40,m_fast'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 2"
                      />
                      <div
                        class="table_area_log_item_title_a"
                        style="margin-left: 1rem"
                      >
                        {{ scope.row.contentDetailJs.photoName }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 20 &&
                        scope.row.contentDetailJs.posterName1 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第一行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName1 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 20 &&
                        scope.row.contentDetailJs.posterName2 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第二行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName2 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 20 &&
                        scope.row.contentDetailJs.posterName3 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第三行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName3 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 20 &&
                        scope.row.contentDetailJs.posterName4 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>第四行文案：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.posterName4 }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.name &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>纪念堂名称：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.name }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.gender &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>性别：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.gender }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.calendarState &&
                        scope.row.calendarState != ''
                      "
                    >
                      <div>生/忌辰显示：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.calendarState}}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.birthday &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>生辰：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.birthday }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.deadday &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>忌辰：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.deadday }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.coverUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>纪念堂封面：</div>
                      <img
                        :src="scope.row.contentDetailJs.coverUrl"
                        class="table_area_log_item_img"
                      />
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.lifeTitle &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>生平标题：</div>
                      <div
                        class="table_area_log_item_title"
                        v-html="scope.row.contentDetailJs.lifeTitle"
                      ></div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.lifeStory &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>生平：</div>
                      <div
                        class="table_area_log_item_title"
                        v-html="scope.row.contentDetailJs.lifeStory"
                      ></div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.bgId &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>风格模板：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.bgId }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 28 &&
                        scope.row.contentDetailJs.msId &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>音乐：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.msId }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 23 &&
                        scope.row.contentDetailJs.name &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>相册名称：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.name }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 23 &&
                        scope.row.contentDetailJs.showScope &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>查看权限：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.showScope == 1 ? '仅自己可见':(scope.row.contentDetailJs.showScope == 2 ? '所有管理员可见':'所有人可见（管理员及访客）')}}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 23 &&
                        scope.row.contentDetailJs.coverUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>相册封面：</div>
                      <img
                        :src="scope.row.contentDetailJs.coverUrl"
                        class="table_area_log_item_img_photo"
                      />
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 24 &&
                        scope.row.contentDetailJs.name &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>相册名称：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.name }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 24 &&
                        scope.row.contentDetailJs.showScope &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>查看权限：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.showScope == 1 ? '仅自己可见':(scope.row.contentDetailJs.showScope == 2 ? '所有管理员可见':'所有人可见（管理员及访客）')}}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 24 &&
                        scope.row.contentDetailJs.coverUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>相册封面：</div>
                      <img
                        :src="scope.row.contentDetailJs.coverUrl"
                        class="table_area_log_item_img_photo"
                      />
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 25 &&
                        scope.row.contentDetailJs.name &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>相册名称：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.name }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 25 &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>含文件：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.photoCount }}个
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 26 &&
                        scope.row.contentDetailJs.photoUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>描述文件：</div>
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=image/resize,m_fill,h_40,w_40'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 1"
                      />
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=video/snapshot,t_1000,f_jpg,w_40,h_40,m_fast'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 2"
                      />
                      <div
                        class="table_area_log_item_title_a"
                        style="margin-left: 1rem"
                      >
                        {{ scope.row.contentDetailJs.remark }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 27 &&
                        scope.row.contentDetailJs.photoUrl &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>迁移文件：</div>
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=image/resize,m_fill,h_40,w_40'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 1"
                      />
                      <img
                        :src="
                          scope.row.contentDetailJs.photoUrl +
                          '?x-oss-process=video/snapshot,t_1000,f_jpg,w_40,h_40,m_fast'
                        "
                        class="table_area_log_item_update_img"
                        v-if="scope.row.contentDetailJs.photoType == 2"
                      />
                      <div
                        class="table_area_log_item_title_a"
                        style="margin-left: 1rem"
                      >
                        {{ scope.row.contentDetailJs.photoName }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 27 &&
                        scope.row.contentDetailJs.originalCategoryName &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>迁移前位置：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.originalCategoryName }}
                      </div>
                    </div>
                    <div
                      class="table_area_log_item"
                      v-if="
                        scope.row.type == 27 &&
                        scope.row.contentDetailJs.originalCategoryName &&
                        scope.row.contentDetailJs != ''
                      "
                    >
                      <div>迁移后位置：</div>
                      <div class="table_area_log_item_title">
                        {{ scope.row.contentDetailJs.categoryName }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="createTime"
                label="操作日期"
              ></el-table-column>
              <template slot="empty">
                <table-empty></table-empty>
              </template>
            </el-table>
          </div>
          <div class="page_area">
            <el-pagination
              :current-page.sync="pageManagementLog.page"
              layout="total, prev, pager, next, jumper"
              :total="pageManagementLog.total"
              @current-change="handleCurrentChangeLog"
              :page-size="10"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import TableEmpty from "../../../../components/TableEmpty.vue";
import mixin from "./Mixins";
import { _editSpaceFrozenSendCode } from "@/api/Common";
import { catchErr, roundAll } from "@/utils/utils";
import OSSUpload from "@/components/OSSUpload";

export default {
  components: { TableEmpty, OSSUpload },
  mixins: [mixin],
  data() {
    var validateName = (rule, value, callback) => {
      value = value.replace(/(^\s*)|(\s*$)/g, "");
      var reg = /[（）()·a-zA-Z0-9\u0391-\uFFE5]+/;
      var regChar =
        /[\`\~\!\@\#\$\%\^\&\*\-\_\+\=\[\{\]\}\\\|\;\:\'\"\,\<\.\>\/\?\/\*\-\+\.\~\！\@\#\￥\%\…\…\&\*\—\—\+\{\}\【\】\、\|\；\：\‘\’\“\”\，\《\》\。\、\？]+/;
      if (value != "") {
        if (value.length < 2 || value.length > 30) {
          callback(new Error("* 请填写2-30位主办人姓名"));
        } else {
          // if (reg.test(value) && !regChar.test(value)) {
          //   callback();
          // } else {
          //   callback(new Error("*不能包含特殊字符"));
          // }
          callback();
        }
      } else {
        callback();
      }
    };

    var valideadName = (rule, value, callback) => {
      value = value.replace(/(^\s*)|(\s*$)/g, "");
      if (value != "" && value.length >= 2) {
        callback();
      } else {
        callback(new Error("*请填写2-30位纪念堂名称"));
      }
    };

    var validatePhone = (rule, value, callback) => {
      if (value.length != 11) {
        callback(new Error("*请输入正确手机号"));
      }
      if (value == "11111111111") {
        callback();
      } else {
        var reg = /^[1][3-9][0-9]{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("*请输入正确手机号"));
        }
      }
    };
    var validateCoverType = (rule, value, callback) => {
      if (value == 0 && !this.createForm.coverUrl) {
        callback(new Error("*请上传纪念堂封面"));
      } else {
        callback();
      }
    };
    return {
      datePickerOptionsB: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      datePickerOptionsA: {
        disabledDate(time) {
          return time.getTime() < new Date("2021-01-01");
        },
      },
      datePickerOptions: {
        disabledDate(time) {
          return (
            time.getTime() > Date.now() ||
            time.getTime() < new Date("2021-01-01")
          );
        },
      },
      pickerBeginDateAfter: {
        disabledDate(time) {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() > Date.now() + 3600 * 1000 * 24 * 6
          );
        },
      },

      pms: {
        listAll: false,
        listV: false,
        listS: false,
        create: false,
        change: false,
        log: false,
        relieveS: false,
        relieveV: false,
        details: false,
        remark: false,
        projectionScreen: false,
        sweep: false,
      },

      unfreezeCallerDialog: false,
      unfreezeSpaceDialog: false,
      createSpaceDialog: false,
      messageClock: "",
      subscribeOfficeDialog: false,
      isCreate: true,
      createRules: {
        deadName: [
          {
            required: true,
            min: 2,
            max: 30,
            message: "* 请填写2-30位纪念堂名称",
            trigger: "blur",
          },
        ],
        name: [
          {
            required: true,
            min: 2,
            max: 30,
            message: "* 请填写2-30位纪念堂名称",
            trigger: "blur",
          },
          {
            validator: valideadName,
            trigger: "blur",
          },
          // {
          //   validator: validateName,
          //   trigger: "blur",
          // },
        ],
        undertakerName: [
          {
            validator: validateName,
            trigger: "blur",
          },
        ],
        undertakerTel: [
          {
            required: true,
            min: 11,
            max: 11,
            message: "* 请输入正确的联系方式",
            trigger: "blur",
          },
          {
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        coverType: [
          { required: true, message: "请选择纪念堂封面", trigger: "blur" },
          { validator: validateCoverType, trigger: "blur" },
        ],
      },
      officeRules: {
        office: [
          {
            required: true,
            message: "* 此项为必填项",
            trigger: "blur",
          },
        ],
        date: [
          {
            required: true,
            message: "* 此项为必填项",
            trigger: "blur",
          },
        ],
      },
      tableLog: false,
      dmId: "",
      LogId: "",

      visitorFrozenContentNew: "",
      visitorFrozenContent: "",
      unfreeId: "",

      timerClock: null,
      totleTimeClock: 60,
      isCanClick: false,
      isCanClickAgain: true,

      remarkDialog: false,
      remarkName: "",
      remarkBirthday: "",
      remarkDeadday: "",
      remarkId: "",
      remarkNamePeo: "",
    };
  },
  computed: {
    drawarWidth() {
      let result = 130.0 * this.docFontSize;
      let percent = (result / document.body.clientWidth) * 100;
      return `${percent}%`;
    },
    numberLog: {
      get: function () {
        return this.SpaceManagement.spaceManagement.numberLog;
      },
      set: function (v) {
        this.SETLOGNUMBER(v);
      },
    },
    number: {
      get: function () {
        return this.SpaceManagement.spaceManagement.number;
      },
      set: function (v) {
        this.SETNUMBER(v);
      },
    },
    title: {
      get: function () {
        return this.SpaceManagement.spaceManagement.title;
      },
      set: function (v) {
        this.SETTITLE(v);
      },
    },
    spaceSearchForm() {
      return this.SpaceManagement.spaceManagement.spaceSearchForm;
    },
    farewellOfficeList() {
      return this.SpaceManagement.spaceManagement.farewellOfficeList;
    },
    findAppInfoAllList() {
      return this.SpaceManagement.spaceManagement.findAppInfoAllList;
    },
    stateList() {
      return this.SpaceManagement.spaceManagement.stateList;
    },
    changeStateList() {
      return this.SpaceManagement.spaceManagement.changeStateList;
    },
    pageManagementLog() {
      return this.SpaceManagement.spaceManagement.pageManagementLog;
    },
    pageManagementAll() {
      return this.SpaceManagement.spaceManagement.pageManagementAll;
    },
    pageManagementV() {
      return this.SpaceManagement.spaceManagement.pageManagementV;
    },
    pageManagementS() {
      return this.SpaceManagement.spaceManagement.pageManagementS;
    },
    totalList() {
      return this.SpaceManagement.spaceManagement.totalList;
    },
    createForm() {
      return this.SpaceManagement.spaceManagement.createForm;
    },
    officeForm() {
      return this.SpaceManagement.spaceManagement.officeForm;
    },
    officeList() {
      return this.SpaceManagement.spaceManagement.officeList;
    },
    spaceLogForm() {
      return this.SpaceManagement.spaceManagement.spaceLogForm;
    },
    logList() {
      return this.SpaceManagement.spaceManagement.logList;
    },
    loginMobileStateList() {
      return this.SpaceManagement.spaceManagement.loginMobileStateList;
    },
    coverType0: {
      get() {
        return this.createForm.coverType == 0;
      },
      set(v) {
        if (v) {
          this.createForm.coverType = 0;
        } else {
          this.createForm.coverType = 1;
        }
      },
    },
    coverType1: {
      get() {
        return this.createForm.coverType == 1;
      },
      set(v) {
        if (v) {
          this.createForm.coverType = 1;
        } else {
          this.createForm.coverType = 0;
        }
        this.$refs.createForm.validate((valid) => {});
      },
    },
  },
  filters: {
    remarkLength(v) {
      if (v) {
        return v.length;
      } else {
        return 0;
      }
    },
  },
  created() {
    //处理返回键
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", function () {
      history.pushState(null, null, document.URL);
    });
    let pms = JSON.parse(window.sessionStorage.getItem("binyi_cms_pms"));
    //全部列表
    this.pms.listAll = !pms["50104"].check;
    //访客冻结列表
    this.pms.listV = !pms["50204"].check;
    //纪念堂冻结列表
    this.pms.listS = !pms["50304"].check;
    //新建
    this.pms.create = pms["50400"].check;
    //预约告别厅/修改预约
    this.pms.change = pms["50500"].check;
    //日志
    this.pms.log = pms["50600"].check;
    //解除冻结纪念堂
    this.pms.relieveS = pms["50700"].check;
    //解除冻结访问码
    this.pms.relieveV = pms["50800"].check;
    //详情
    this.pms.details = pms["51000"].check;
    //备注
    this.pms.remark = pms["50900"].check;
    //投屏
    this.pms.projectionScreen = pms["51100"].check;
    //线下祭祀
    this.pms.sweep = pms["51200"].check;

    this.isCanClick = !JSON.parse(
      window.sessionStorage.getItem("binyi_cms_loginInfo")
    ).validateRole;

    this.findAllList();
    this.findAppInfoAll();

    if (this.pms.listAll || this.pms.listV || this.pms.listS) {
      if (this.pms.listAll) {
        this.findSpaceList();
      } else if (this.pms.listV) {
        this.SpaceManagement.spaceManagement.title == 1;
        this.findSpaceList();
      } else if (this.pms.listS) {
        this.SpaceManagement.spaceManagement.title == 2;
        this.findSpaceList();
      }
    }
  },
  mounted() {
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(4);
  },
  methods: {
    dialogRemarkSave() {
      if (
        this.remarkBirthday != null &&
        this.remarkBirthday != "" &&
        this.remarkDeadday != null &&
        this.remarkDeadday != ""
      ) {
        var stdt = new Date(this.remarkBirthday.replace("-", "/"));
        var etdt = new Date(this.remarkDeadday.replace("-", "/"));
        if (stdt > etdt) {
          this.$message.error("生辰日期必须小于忌辰日期");
          return;
        }
      }
      this.remarkName = this.remarkName.replace(/(^\s*)|(\s*$)/g, "");
      this.remarkNamePeo = this.remarkNamePeo.replace(/(^\s*)|(\s*$)/g, "");
      let params = {
        id: this.remarkId,
        remarkName: this.remarkName,
        remarkBirthday: this.remarkBirthday,
        remarkDeadday: this.remarkDeadday,
        undertakerName: this.remarkNamePeo,
      };
      this.editDeadNameById(params).then((res) => {
        if (res) {
          this.$message.success("备注成功");
          this.remarkDialog = false;
          this.remarkName = "";
          this.remarkNamePeo = "";
          this.remarkBirthday = "";
          this.remarkDeadday = "";
          this.remarkId = "";
          this.findSpaceList();
        }
      });
    },
    dialogRemarkCancel() {
      this.remarkName = "";
      this.remarkNamePeo = "";
      this.remarkBirthday = "";
      this.remarkDeadday = "";
      this.remarkId = "";
      this.remarkDialog = false;
    },
    handleRemarkClose(done) {
      this.remarkName = "";
      this.remarkNamePeo = "";
      this.remarkBirthday = "";
      this.remarkDeadday = "";
      this.remarkId = "";
      done();
    },
    toRemark(v) {
      this.remarkDialog = true;
      this.remarkId = v.id;
      if (v.remarkName != "—") {
        this.remarkName = v.remarkName;
      }
      if (v.undertakerName != "—") {
        this.remarkNamePeo = v.undertakerName;
      }
      if (v.remarkBirthday != "—") {
        this.remarkBirthday = v.remarkBirthday;
      }
      if (v.remarkDeadday != "—") {
        this.remarkDeadday = v.remarkDeadday;
      }
    },
    handle(val) {
      console.log(val);
      if (val.length > 30) {
        this.SpaceManagement.spaceManagement.spaceSearchForm.appShortName =
          val.substring(0, 30);
      }
    },
    setBlur() {
      //  在点击由 clearable 属性生成的清空按钮时，主动触发失去焦点，解决‘fetch-suggestions’输入建议不提示的bug
      document.activeElement.blur();
    },
    querySearch(queryString, cb) {
      var restaurants = this.SpaceManagement.spaceManagement.findAppInfoAllList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !=
          -1
        );
      };
    },
    handleSelect(item) {
      console.log(item);
      this.SpaceManagement.spaceManagement.spaceSearchForm.appShortNameChoice =
        item.appShortName;
      this.SpaceManagement.spaceManagement.spaceSearchForm.appShortNameChoiceId =
        item.appId;
    },
    //查询
    search() {
      console.log(this.SpaceManagement.spaceManagement.spaceSearchForm);
      if (this.SpaceManagement.spaceManagement.title == 0) {
        this.SpaceManagement.spaceManagement.pageManagementAll = {
          page: 1,
          size: 10,
          total: 0,
        };
      } else if (this.SpaceManagement.spaceManagement.title == 1) {
        this.SpaceManagement.spaceManagement.pageManagementV = {
          page: 1,
          size: 10,
          total: 0,
        };
      } else if (this.SpaceManagement.spaceManagement.title == 2) {
        this.SpaceManagement.spaceManagement.pageManagementS = {
          page: 1,
          size: 10,
          total: 0,
        };
      }
      this.findSpaceList();
    },
    //切换
    changeTitle(v) {
      this.title = v;
      this.findSpaceList();
    },
    handleSizeChange(v) {
      if (this.SpaceManagement.spaceManagement.title == 0) {
        this.SpaceManagement.spaceManagement.pageManagementAll.size = v;
      } else if (this.SpaceManagement.spaceManagement.title == 1) {
        this.SpaceManagement.spaceManagement.pageManagementV.size = v;
      } else if (this.SpaceManagement.spaceManagement.title == 2) {
        this.SpaceManagement.spaceManagement.pageManagementS.size = v;
      }
      this.findSpaceList();
    },
    handleCurrentChange(v) {
      this.findSpaceList();
    },
    handleCurrentChangeLog(v) {
      let params = {
        dmId: this.LogId,
      };
      this.findLog(params).then((res) => {
        if (res.status == 1098) {
          this.showCo();
          this.tableLog = false;
          this.LogId = "";
          this.SpaceManagement.spaceManagement.spaceLogForm = {
            createUserName: "",
            content: "",
            date: "",
          };
          this.SpaceManagement.spaceManagement.logList = [""];
          this.SpaceManagement.spaceManagement.numberLog = "";
          this.SpaceManagement.spaceManagement.pageManagementLog = {
            page: 1,
            size: 10,
            total: 0,
          };
          this.findSpaceList();
        }
      });
    },
    toDetails(v) {
      console.log(v);
      let routeData = this.$router.resolve({
        path: "/spacedetails",
        query: {
          id: v.id,
        },
      });
      window.open(routeData.href, "_blank");
    },
    //解冻访问码
    unfreezeCaller(v) {
      this.unfreeId = v.id;
      this.findById(v.id).then((res) => {
        this.unfreezeCallerDialog = true;
        this.visitorFrozenContentNew = res.data;
        this.visitorFrozenContent = JSON.parse(res.data.visitorFrozenContent);
        console.log(this.visitorFrozenContent);
      });
    },
    handleCallerClose(done) {
      this.visitorFrozenContent = "";
      this.visitorFrozenContentNew = "";
      done();
    },
    callerCancle() {
      this.visitorFrozenContent = "";
      this.visitorFrozenContentNew = "";
      this.unfreezeCallerDialog = false;
    },
    callerReject() {
      this.editVisitorFrozenById({
        id: this.unfreeId,
        status: 3,
        remark: this.visitorFrozenContentNew.visitorFrozenRemark,
      }).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("驳回成功");
          this.visitorFrozenContent = "";
          this.visitorFrozenContentNew = "";
          this.unfreezeCallerDialog = false;
          this.findSpaceList();
        }
      });
    },
    callerQuery() {
      this.editVisitorFrozenById({
        id: this.unfreeId,
        status: 4,
        //remark: this.visitorFrozenContentNew.visitorFrozenRemark,
      }).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("解冻成功");
          this.visitorFrozenContent = "";
          this.visitorFrozenContentNew = "";
          this.unfreezeCallerDialog = false;
          this.findSpaceList();
        }
      });
    },
    //解冻纪念堂
    unfreezeSpace(v) {
      this.unfreeId = v.id;
      this.unfreezeSpaceDialog = true;
    },
    //投屏
    projectionScreen(v) {
      if(v.spaceFrozen != 0){
        this.$message.error("请先解除冻结");
        return
      }
      if(v.statusName == '过期') {
        this.$message.error("纪念堂已过期不可使用");
        return
      }
      this.LogId = v.id;
      let params = {
        dmId: v.id,
      };
      this.findLog(params).then((res) => {
        if (res.status == 1098) {
          this.showCo();
          this.findSpaceList();
        } else {
          this.$router.push({
            path: "/video",
            query: {
              id: v.id,
            },
          });
        }
      });
    },
    //线下祭祀
    sweep(v) {
      let routeData = this.$router.resolve({
        path: "/sweep",
        query: {
          id: v.id,
        },
      });
      window.open(routeData.href, "_blank");
    },

    handleSpaceClose(done) {
      this.unfreezeSpaceDialog = false;
      this.messageClock = "";
      window.clearInterval(this.timerClock);
      this.timerClock = null;
      this.totleTimeClock = 60;
      done();
    },
    callerSpaceCancle() {
      this.unfreezeSpaceDialog = false;
      this.messageClock = "";
      window.clearInterval(this.timerClock);
      this.timerClock = null;
      this.totleTimeClock = 60;
    },
    callerSpaceQuery() {
      if (this.messageClock == "") {
        this.$message.error("请输入验证码");
        return;
      }
      let params = {
        id: this.unfreeId,
        status: 4, //1冻结， 4解冻
        code: this.messageClock,
      };
      this.editSpaceFrozenById(params).then((res) => {
        console.log(res);
        if (res.status == 1000) {
          this.$message.success("纪念堂解冻成功");
          this.unfreezeSpaceDialog = false;
          this.messageClock = "";
          window.clearInterval(this.timerClock);
          this.timerClock = null;
          this.totleTimeClock = 60;
          this.findSpaceList();
        } else if (res.status == 1018) {
          this.$message.error("验证码不正确，请输入正确的验证码");
        } else if (res.status == 1019) {
          this.$message.error("验证码不正确，请输入正确的验证码");
        } else if (res.status == 1098) {
          this.showCo();
          this.unfreezeSpaceDialog = false;
          this.messageClock = "";
          window.clearInterval(this.timerClock);
          this.timerClock = null;
          this.totleTimeClock = 60;
          this.findSpaceList();
        } else {
          this.$message.error("验证码不正确，请输入正确的验证码");
        }
      });
    },

    //新建
    createSpace() {
      this.SpaceManagement.spaceManagement.createForm = {
        name: "",
        undertakerName: "",
        undertakerTel: "",
        coverUrl: "",
        coverType: 0,
        coverImages: [],
        deadName: "",
      };
      this.createSpaceDialog = true;
    },
    handleClose(done) {
      done();
      this.$refs.createForm.resetFields();
      this.SpaceManagement.spaceManagement.createForm = {
        name: "",
        undertakerName: "",
        undertakerTel: "",
        coverUrl: "",
        coverType: 0,
        coverImages: [],
        deadName: "",
      };
    },
    dialogSave(createForm) {
      this.$refs.createForm.validate((valid) => {
        if (valid) {
          if (this.isCanClickAgain) {
            this.isCanClickAgain = false;
            this.addSpace().then((res) => {
              console.log(res);
              if (res.status == 1000) {
                this.$message.success("操作成功");
                this.createSpaceDialog = false;
                this.isCanClickAgain = true;
                this.SpaceManagement.spaceManagement.createForm = {
                  name: "",
                  undertakerName: "",
                  undertakerTel: "",
                  coverUrl: "",
                  coverType: 0,
                  coverImages: [],
                  deadName: "",
                };
                this.$refs.createForm.resetFields();
                if (this.SpaceManagement.spaceManagement.title == 0) {
                  this.SpaceManagement.spaceManagement.pageManagementAll = {
                    page: 1,
                    size: 10,
                    total: 0,
                  };
                } else if (this.SpaceManagement.spaceManagement.title == 1) {
                  this.SpaceManagement.spaceManagement.pageManagementV = {
                    page: 1,
                    size: 10,
                    total: 0,
                  };
                } else if (this.SpaceManagement.spaceManagement.title == 2) {
                  this.SpaceManagement.spaceManagement.pageManagementS = {
                    page: 1,
                    size: 10,
                    total: 0,
                  };
                }
                this.findSpaceList();
              } else {
                this.isCanClickAgain = true;
              }
            });
          }
        }
      });
    },
    dialogCancel(createForm) {
      this.SpaceManagement.spaceManagement.createForm = {
        name: "",
        undertakerName: "",
        undertakerTel: "",
        coverUrl: "",
        coverType: 0,
        coverImages: [],
      };
      this.$refs.createForm.resetFields();
      this.createSpaceDialog = false;
    },

    //预约告别厅
    subscribeOffice(v) {
      console.log(v);
      //v.amList
      this.dmId = v.id;
      this.findAllListCreate().then((res) => {
        if (v.amList != undefined) {
          v.amList.forEach((item) => {
            if (
              item.unitId ==
              JSON.parse(window.sessionStorage.getItem("binyi_cms_loginInfo"))
                .unitId
            ) {
              this.SpaceManagement.spaceManagement.officeForm = {
                office: item.fhId,
                date: item.useDate,
                startTime: item.startTime.substring(0, 5),
                endTime: item.endTime.substring(0, 5),
              };
            }
          });
        }
      });
      this.subscribeOfficeDialog = true;
      this.isCreate = true;
    },
    // changeOffice() {
    //   this.subscribeOfficeDialog = true;
    //   this.isCreate = false;
    // },
    handleOfficeClose(done) {
      this.$refs.officeForm.resetFields();
      this.SpaceManagement.spaceManagement.officeForm = {
        office: "",
        date: "",
        startTime: "",
        endTime: "",
      };
      done();
    },
    dialogOfficeSave(officeForm) {
      this.$refs[officeForm].validate((valid) => {
        if (valid) {
          console.log(this.SpaceManagement.spaceManagement.officeForm);
          this.addOrEdit({ dmId: this.dmId }).then((res) => {
            console.log(res);
            if (res.status == 1000) {
              this.$message.success("预约成功");
              this.$refs[officeForm].resetFields();
              this.subscribeOfficeDialog = false;
              this.SpaceManagement.spaceManagement.officeForm = {
                office: "",
                date: "",
                startTime: "",
                endTime: "",
              };
              this.findSpaceList();
            } else if (res.status == 1078) {
              this.$message.error("告别会一结束，不可预约告别厅");
            } else if (res.status == 1098) {
              this.showCo();
              this.$refs[officeForm].resetFields();
              this.subscribeOfficeDialog = false;
              this.SpaceManagement.spaceManagement.officeForm = {
                office: "",
                date: "",
                startTime: "",
                endTime: "",
              };
              this.findSpaceList();
            }
          });
        }
      });
    },
    showCo() {
      this.$Confirm("纪念堂已失效，请返回纪念堂列表页面刷新", "提示", {
        type: "warning",
        showCancelButton: false,
      })
        .then(() => {})
        .catch(() => {});
    },
    dialogOfficeCancel(officeForm) {
      this.$refs[officeForm].resetFields();
      this.subscribeOfficeDialog = false;
      this.SpaceManagement.spaceManagement.officeForm = {
        office: "",
        date: "",
        startTime: "",
        endTime: "",
      };
    },
    //上传纪念堂封面
    coverFileInfo(file) {
      console.log(file);
      this.createForm.coverUrl = file[0].url;
      //var arrImages = [file[0], file[1]];
      //this.createForm.coverImages = arrImages;

      console.log(this.createForm.coverUrl);
    },
    //选择告别厅
    selectChange(v) {
      console.log(v);
    },

    //日志
    showLog(v) {
      console.log(v);
      this.tableLog = true;
      this.LogId = v.id;
      let params = {
        dmId: v.id,
      };
      this.findLog(params).then((res) => {
        if (res.status == 1098) {
          this.showCo();
          this.tableLog = false;
          this.LogId = "";
          this.SpaceManagement.spaceManagement.spaceLogForm = {
            createUserName: "",
            content: "",
            date: "",
          };
          this.SpaceManagement.spaceManagement.logList = [""];
          this.SpaceManagement.spaceManagement.numberLog = "";
          this.SpaceManagement.spaceManagement.pageManagementLog = {
            page: 1,
            size: 10,
            total: 0,
          };
          this.findSpaceList();
        }
      });
    },
    searchLog() {
      let params = {
        dmId: this.LogId,
      };
      this.findLog(params).then((res) => {
        if (res.status == 1098) {
          this.showCo();
          this.tableLog = false;
          this.LogId = "";
          this.SpaceManagement.spaceManagement.spaceLogForm = {
            createUserName: "",
            content: "",
            date: "",
          };
          this.SpaceManagement.spaceManagement.logList = [""];
          this.SpaceManagement.spaceManagement.numberLog = "";
          this.SpaceManagement.spaceManagement.pageManagementLog = {
            page: 1,
            size: 10,
            total: 0,
          };
          this.findSpaceList();
        }
      });
    },
    handleCloseLog(done) {
      this.LogId = "";
      this.SpaceManagement.spaceManagement.spaceLogForm = {
        createUserName: "",
        content: "",
        date: "",
      };
      this.SpaceManagement.spaceManagement.logList = [""];
      this.SpaceManagement.spaceManagement.numberLog = "";
      this.SpaceManagement.spaceManagement.pageManagementLog = {
        page: 1,
        size: 10,
        total: 0,
      };
      done();
    },

    async getMessageClock() {
      let data = this.unfreeId;
      let [err, res] = await catchErr(
        _editSpaceFrozenSendCode(
          {
            data: data,
          },
          this.unfreeId
        )
      );
      if (err) {
        if (err.status == 1098) {
          this.showCo();
          this.unfreezeSpaceDialog = false;
          this.messageClock = "";
          window.clearInterval(this.timerClock);
          this.timerClock = null;
          this.totleTimeClock = 60;
          this.findSpaceList();
          return;
        }
        this.$message.error(err.message || "发送失败");
      } else {
        this.$message.success("发送成功");
        this.timerClock = window.setInterval(() => {
          this.totleTimeClock--;
          if (this.totleTimeClock <= 0) {
            window.clearInterval(this.timerClock);
            this.timerClock = null;
            this.totleTimeClock = 60;
          }
        }, 1000);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.space_management_background {
  width: 100%;
  height: 100%;
  background: #FFFFFF;

  .btn_create {
    background-color: #2C90FF;
    width: 100px;
    height: 40px;
    color: #fff;
    padding: 0 20px;
    float: right;

    .btn_content {
      display: flex;
      align-items: center;
    }

    .icon-create {
      background: url('~@/assets/images/Total/icon_create.png') no-repeat;
      width: 18px;
      height: 18px;
      display: inline-block;
      margin-right: 10px;
      background-size: 100%;
    }

    .text_create {
      display: inline-block;
    }
  }

  .space_title {
    height: 70px;
    line-height: 70px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    padding-left: 30px;
    border-bottom: 1px solid #E9ECF3;
  }

  .search_area {
    width: 100%;
    border-bottom: 1px solid #E9ECF3;
    height: 204px;
  }

  .search_area_log {
    margin-left: 30px;
    width: 1210px;
    border: 1px solid #CCD7EA;
    min-height: 124px;
    padding-top: 20px;
  }

  .search_area_log_middle {
    overflow: auto;
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    top: 80px;
  }

  .search_item {
    // float: left;
    height: 40px;
    margin: 20px 0 20px 30px;
  }

  .search_item_c {
    float: left;
    height: 40px;
  }

  .search_item >>>.el-form-item__label {
    color: #040300;
  }

  .search_item >>>.el-input__icon {
    margin-top: 1px;
  }

  .search_item_b {
    height: 40px;
    margin: 0 0 20px 30px;
  }

  .search_item_b >>>.el-form-item__label {
    color: #040300;
  }

  .search_item_c >>>.el-form-item__label {
    color: #040300;
  }

  .search_item_a >>>.el-form-item__label {
    color: #040300;
  }

  .search_input >>>.el-input__inner {
    width: 220px;
  }

  .search_button {
    width: 100px;
  }

  .line {
    margin-left: 30px;
    width: 1532px;
    height: 1px;
    background: #CCD7EA;
  }

  .space_list_title {
    display: flex;
    flex-direction: row;
    width: 100%;
    height: 70px;
    line-height: 70px;
  }

  .space_list_title_item {
    position: relative;
    height: 70px;
    line-height: 70px;
    cursor: pointer;
  }

  .space_list_title_text {
    height: 70px;
    line-height: 70px;
    font-size: 20px;
    font-weight: 500;
    color: #2C90FF;
    box-sizing: border-box;
  }

  .space_list_title_text_no {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    box-sizing: border-box;
  }

  .space_list_title_line {
    position: absolute;
    bottom: 0;
    width: 40px;
    height: 4px;
    background: #2C90FF;
  }

  .space_middle_all {
    background-color: #fff;
    position: absolute;
    left: 3rem;
    bottom: 0;
    right: 3rem;
    top: 38rem;
    overflow: auto;
  }

  .space_middle {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 80px;
    line-height: 80px;
    padding-left: 30px;
    padding-right: 30px;

    .space_middle_total {
      font-size: 16px;
      font-weight: 500;
      color: #000000;
    }

    .space_middle_number {
      font-size: 16px;
      font-weight: 500;
      color: #2C90FF;
    }
  }

  .table_area {
    margin-left: 30px;
    margin-right: 30px;

    .bt_cancle {
      margin-left: 0px;
    }

    .v_item_name_small {
      max-width: 150px;
      overflow: hidden; // 超出部分隐藏
      text-overflow: ellipsis; // 隐藏部分用...代替
      // white-space: nowrap;
      white-space: pre || nowrap;
    }
  }

  .v_item_name_a {
    max-width: 190px;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
  }

  .v_item_name {
    max-width: 190px;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
  }

  .table_area >>>.el-table__header thead {
    tr, th {
      background-color: #F7FAFF;
    }
  }

  .table_area >>>.cell {
    margin-left: 5px;
  }

  .table_area_log_all {
    background-color: #fff;
    position: absolute;
    left: 0;
    bottom: 0;
    width: 1210px;
    // right: 0;
    top: 147px;
    overflow: auto;
    margin-left: 30px;
  }

  .table_area_log {
    // width: 1210px;
  }

  .table_area_log >>>.el-table th {
    background-color: #F7FAFF !important;
  }

  .table_area_log_item {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .table_area_log_item_title {
    max-width: 350px;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
    max-height: 100px;
  }

  .table_area_log_item_title_a {
    max-width: 300px;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
  }

  .table_area_log_item_img {
    width: 85px;
    height: 114px;
  }

  .table_area_log_item_img_photo {
    width: 85px;
    height: 85px;
  }

  .table_area_log_item_update_img {
    width: 40px;
    height: 40px;
  }

  .table_area_log_item_text {
    max-width: 420px;
  }

  .page_area_a {
    padding: 0;

    .el-pagination {
      text-align: center;
    }

    .el-pagination__total {
      color: #333333;
      font-size: 12px;
    }
  }

  .page_area {
    padding-top: 15px;
  }

  .page_area >>> .el-input__inner {
    border: 1px solid #DCDFE6;
  }

  .page_area {
    height: 30px;
    padding-top: 35px;
    padding-bottom: 15px;

    .el-pagination {
      text-align: center;
    }

    .el-pagination__total {
      color: #333333;
      font-size: 12px;
    }
  }

  .dialog_body {
    display: flex;
    flex-direction: row;

    .body_left {
      .body_left_title {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 99px;
      }

      .body_left_title_text {
        font-size: 14px;
        font-weight: 400;
        color: #040300;
      }

      .body_left_title_content {
        margin-left: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 500px;
        border-radius: 2px;
        border: 1px solid #E6E6E6;
        height: 40px;
        line-height: 40px;
      }

      .body_left_title_content_text {
        margin-left: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
      }

      .body_left_title_content_number {
        font-size: 14px;
        font-weight: 400;
        color: #4EA2FF;
      }

      .body_left_title_content_number_black {
        margin-right: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
      }

      .body_left_middle {
        display: flex;
        flex-direction: row;
      }

      .body_left_middle_content {
        margin-left: 10px;
        width: 500px;
        height: 522px;
        border-radius: 2px;
        border: 1px solid #E6E6E6;
        display: flex;
        flex-direction: column;
        padding: 10px;
        box-sizing: border-box;
        overflow: auto;
      }
    }

    .body_right {
      margin-top: 99px;
      display: flex;
      flex-direction: row;
      margin-left: 30px;

      .body_right_title_text {
        margin-left: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #000000;
      }

      .body_right_middle_content {
        margin-left: 10px;
        width: 500px;
        height: 522px;
        border-radius: 2px;
        border: 1px solid #E6E6E6;
        display: flex;
        flex-direction: column;
        padding: 10px;
        box-sizing: border-box;
        overflow: auto;
      }
    }

    .little_title {
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      margin-bottom: 10px;
    }

    .little_text {
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 10px;
    }

    .little_img {
      width: 80px;
      height: 80px;
      background: #2C90FF;
      margin-bottom: 10px;
    }

    .little_img_list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
  }

  .dialog_body_space {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .space_input {
    width: 220px;
  }

  .get_phone_message {
    margin-left: 30px;
    background-color: #f66915;
    border-color: #f66915;
  }

  .message_to_phone {
    margin-left: 30px;
    color: #FFFFFF;
    background: #F66915;
    border: 1px solid #F66915;
    width: 110px;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    text-align: center;
    padding: 0;
  }

  .log_number_all {
    height: 62px;
    line-height: 62px;
    font-size: 16px;
    font-weight: 500;
    color: #000000;
  }

  .log_number_blue {
    font-size: 16px;
    font-weight: 500;
    color: #2C90FF;
  }

  .table_area_log >>> .cell {
    margin-left: 40px;
  }

  .endTime {
    margin-left: -5px;
  }

  .startTime {
    margin-left: -5px;
  }

  .unfreeze_title_all {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .unfreeze_title_all_text {
    margin-left: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #040300;
  }

  .unfreeze_title_search_input {
    margin-left: 10px;
    width: 1138px;
  }

  .unfreeze_title_search_input_another {
    margin-left: 10px;
    width: 1138px;
    min-height: 40px;
    line-height: 28px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #E6E6E6;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 66px;
    font-weight: 400;
    color: #000000;
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 6px;
    padding-bottom: 6px;
    position: relative;
  }

  .unfreeze_middle {
    display: flex;
    flex-direction: row;
    margin-top: 30px;
  }

  .unfreeze_middle_title {
    font-size: 14px;
    font-weight: 400;
    color: #040300;
  }

  .unfreeze_middle_content {
    width: 500px;
    height: 522px;
    margin-left: 10px;
    border-radius: 2px;
    border: 1px solid #E6E6E6;
    overflow: auto;
  }

  .unfreeze_middle_content_title {
    font-size: 14px;
    font-weight: 500;
    color: #000000;
    height: 40px;
    line-height: 40px;
    margin-left: 10px;
  }

  .unfreeze_middle_content_text {
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    line-height: 20px;
    margin-left: 10px;
  }

  .unfreeze_middle_img {
    width: 80px;
    height: 80px;
  }

  .v_template_imgs_a {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    .v_template_item_a {
      width: 80px;
      height: 80px;
      margin-bottom: 20px;
    }

    .iv_template_a {
      width: 80px;
      height: 80px;
    }
  }

  .search_input_big_number_another {
    position: absolute;
    right: 10px;
    bottom: 6px;
    color: #2C90FF;
    font-size: 14px;
    background: #fff;
    line-height: 28px;
  }

  .search_input_big_number_a {
    color: #000000;
    font-size: 14px;
  }

  .upload_tips {
    font-size: 12px;
    color: #FF1A1A;
    line-height: 17px;
    text-align: center;
  }

  .cemetery_use {
    display: flex;
    flex-direction: row;
    justify-content: center;
    position: relative;
  }

  .cemetery_use_title {
    font-size: 14px;
    font-weight: 400;
    color: #040300;
    width: 85px;
    text-align: right;
    margin-right: 10px;
    line-height: 36px;
  }

  .search_input_big {
    width: 220px;
    position: relative;
    min-height: 40px;
  }

  .search_input_big >>> .el-textarea__inner {
    font-family: 'Microsoft Yahei', '微软雅黑', Arial, sans-serif;
    color: #000000;
    border-radius: 0;
    min-height: 40px !important;
    line-height: 2;
  }
}
</style>

<style lang="stylus">
.drawer_change .el-drawer__header {
  font-size: 34px;
  font-weight: 500;
  color: #000000;
}

.drawer_change .el-drawer__close-btn {
  font-size: 30px;
}

.drawer_change .el-drawer__body {
  overflow: auto;
}

.cover_upload_area {
  height: 97px;

  .cover {
    width: 72px;
    height: 96px;
    display: block;
  }
}

.cover_upload_area .coverUrlBorder {
  .el-upload {
    border: 0;

    img {
      width: 171px;
      height: 228px;
    }
  }
}

.cover_upload_area .coverUrlBorder {
  .el-upload {
    border: 0;
    cursor: not-allowed;

    img {
      width: 171px;
      height: 228px;
    }
  }
}

.cover_upload_area .avatar-uploader {
  width: 220px;
  height: 97px;

  .el-upload {
    position: relative;
    // width: 220px;
    height: 97px;
    border: 1px dashed #D9D9D9;
    border-radius: 2px;
  }

  .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 220px;
    height: 97px;
    text-align: center;

    img {
      position: absolute;
      left: 85px;
      top: 10px;
      width: 50px;
      height: 50px;
    }

    p {
      position: absolute;
      left: 86px;
      top: 70px;
      font-size: 12px;
      font-weight: 400;
      color: #B7B7B7;
      height: 17px;
      line-height: 17px;

      span {
        color: #3A81FF;
      }
    }
  }

  .avatar {
    width: 350px;
    height: 105px;
    display: block;
  }

  .cover {
    width: 72px;
    height: 96px;
    display: block;
  }
}

.space_management_background {
  .el-checkbox__input .el-checkbox__inner {
    border-radius: 50%;
  }

  .el-checkbox__label {
    font-weight: 400;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/PartII/SpaceManagement/components/SpaceManagement.vue